import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  ButtonGroup,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Card,
  Alert,
  OverlayTrigger,
  Tooltip,
  Dropdown,
} from "react-bootstrap";

import * as Yup from "yup";
import moment from "moment";
import { Formik } from "formik";
import { Typeahead } from "react-bootstrap-typeahead";

//Tabla, Navbar y Sidebar
import CustomNavbar from "../../../components/CustomNavbar";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";


//Redux

import {
  getCourse,
  saveCourse,
  editCourse,
  deleteCourse
} from "../../../redux/planCarrera/Cursos/actions";
import messages from "../../../redux/messages";
import SidebarPlanCarrera from "../../../components/planCarrera/SidebarPlanCarrera";

const Courses = (props) => {


  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  //
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});

  //
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);

  //

  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "nombre",
    desc: "Nombre del Curso",
  });

  const dispatch = useDispatch();


  const {
    loading,
    saveLoading,
    coursesLength,
    courses,
    courseError,
    formError,
  } = useSelector((store) => store.planCarreraCourse);

  const pages = Math.ceil(coursesLength / limit);

  //Validacion del form
  const schema = Yup.object().shape({
    nombre: Yup.string()
      .required("**Campo requerido")
      .matches(
        /^[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]+$/,
        "**Solo admite letras,numeros y los siguientes caracteres @$¿?!¡/-_%#."
      )
      .test(
        'unique-name',
        '**Ya existe un curso con este mismo nombre',
        function (value) {
          if (!value || edit) return true;
          return !courses.some(course => course.nombre.toLowerCase() === value.toLowerCase());
        }
      ),
      codigo: Yup.string().required("**Campo requerido")

  });


  //Datos para el custom table

  const columns = [
    {
      Header: "Nombre",
      accessor: "nombre",
      Filter: ""
    },
    {
      Header: "codigo",
      accessor: "codigo",
      Filter: ""
    },
    {
      Header: "Fecha de creación",
      accessor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="button-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  // Metodos de cursos

  const getACourse = (off = offset, lim = limit, filt = filter) =>
    dispatch(
      getCourse({
        offset: off,
        limit: lim,
        tipo_busqueda: tipoBusqueda.id,
        filter: filt

      })
    );

  useEffect(() => {
    getACourse();
  }, []);

  const addCourse = () => {
    setShowModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(0);
    setCurrentPage(1);
    getACourse(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = async (req) => {
    const _req = {
      nombre: req.nombre,
      codigo: req.codigo
    };
    console.log(_req)

    if (!edit) {
      dispatch(saveCourse(_req, setShowModal));
    } else {
      dispatch(editCourse(_req, editItem.id, index, setShowModal));
    }

  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getACourse(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    debugger
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteCourse(id, index));
      window.alert("Se borró este curso");
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarPlanCarrera show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6>Cursos</h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-sm-end align-items-center flex-nowrap">
                <Col>
                  <h6>
                    <b>Busqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle mr-1"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      onClick={() => addCourse()}
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                    >
                      <i className="material-icons">add</i>
                    </Button>

                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            coursesLength > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable columns={columns} data={courses} />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={coursesLength}
                  pages={pages}
                  pagFunc={getACourse}
                />
              </>
            )
          )}
          {!loading && coursesLength === 0 && courseError === "" && (
            <Alert variant="info" className="my-4">
              Aún no hay registros, comience creando algunos.
            </Alert>
          )}
          {!!courseError && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {courseError}
            </Alert>
          )}
        </Container>
      </div>
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);

        }}
      >
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            nombre: edit ? editItem.nombre : "",
            codigo: edit ? editItem.codigo : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            setFieldValue,
            values,
            touched,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {edit ? "Editar curso" : "Crear curso"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className={"mt-4 mb-1 mx-3"}>
                    {formError}
                  </Alert>
                )}
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Nombre
                  </Form.Label>
                  <Form.Control
                    id="nombre"
                    name="nombre"
                    isInvalid={touched.nombre && errors.nombre}
                    isValid={touched.nombre && !errors.nombre}
                    onBlur={handleBlur("nombre")}
                    onChange={handleChange}
                    value={values.nombre}
                    className="rounded-pill mb-4"
                    type="text"
                    placeholder="nombre"
                  ></Form.Control>
                  {errors.nombre && touched.nombre && (
                    <Form.Control.Feedback type="invalid">
                      {errors.nombre}
                    </Form.Control.Feedback>
                  )}

                  <Form.Label column sm="12" md="12">
                    Codigo:
                  </Form.Label>
                  <Form.Control
                    id="codigo"
                    name="codigo"
                    isInvalid={touched.codigo && errors.codigo}
                    isValid={touched.codigo && !errors.codigo}
                    onBlur={handleBlur("codigo")}
                    onChange={handleChange}
                    value={values.codigo}
                    className="rounded-pill mb-4"
                    type="text"
                    placeholder="codigo"
                  ></Form.Control>
                  {errors.codigo && touched.codigo && (
                    <Form.Control.Feedback type="invalid">
                      {errors.codigo}
                    </Form.Control.Feedback>
                  )}

                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  variant="primary"
                  disabled={saveLoading}
                  type="submit"

                >
                  {" "}
                  {saveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default Courses;
